/**
 * YARG IE11 you darn thing. This one's simple enough we'll just do it ourselves.
 * https://caniuse.com/?search=findIndex
 */
export const findIndex = <T>(arr: T[], fn: (e: T) => boolean): number => {
    for (let index = 0; index < arr.length; index++) {
        if (fn(arr[index])) {
            return index;
        }
    }
    return -1;
};
